import Range from './Range'
export default class DeliveryRegion {
    ranges = []
    
    constructor(ranges) {
        ranges.map((p) => {
            this.ranges.push(new Range(p.up_to, p.price, p.min_order, p.free_fee, p.old_price, p.minDelivery, p.maxDelivery))
        })
    }

    static getTemplateRange(upTo = 0) {
        return new Range(upTo, 0, 0);
    }
}